export default __webpack_public_path__ + "static/media/ecommerce.739bd6e1.jpg";